export enum DomainOrigin{
    BrokerMobile = 'broker_mobile',
    BrokerCaronte = 'broker_caronte',
    UserDomainMobile = 'user_mobile',
    // UserDomainCaronte = 'user_caronte',
    Mock = 'mock',
    // BrokerCarontePix = 'broker_caronte_pix',
    CaronteContaIon = 'caronte_pix_conta_ion'
}